<template>
  <div class="movie-box page-absolute page-background" :style="layOutStyle">
      <div class="top" :style="topStyle"></div>
      <div class="bottom" :style="botStyle"></div>
  </div>
</template>

<script>
export default {
    name: "MovieBackground",
    props: {
        topStyle: {
            type: Object,
            default: ()=>{}
        },
        botStyle: {
            type: Object,
            default: ()=>{}
        },
        layOutStyle: {
            type: Object,
            default: ()=>{}
        }
    }
}
</script>

<style scoped>
.page-background {
    top: 0;
    left: 0;
    z-index: 0;
  }
  .page-background .top{
    height: 2rem;
    background: linear-gradient(90deg, #FF5A5F 0%, #FF3854 100%);
  }
  .page-background .bottom{
    height: 1rem;
    background: linear-gradient(90deg, #FF5A5F 0%, #FF3854 100%);
    border-radius: 0 0 50% 50%;
  }
</style>